// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3M7wp","item":"PaymentsMobile_item__ntSk6","label":"PaymentsMobile_label__3c3b3","amount":"PaymentsMobile_amount__2NwF7"};